import { Card, CardContent } from '@material-ui/core';
import React from 'react';

export function HtmlDoc({ html }) {
  return (
    <Card>
      <CardContent>
        <div
          style={{
            padding: '12px',
            width: '58vw',
            height: '76vh',
            overflowY: 'auto',
          }}
          dangerouslySetInnerHTML={{ __html: html }}
        ></div>
      </CardContent>
    </Card>
  );
}
